import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import Counter from '@/data/models/tables/Counter'

@OrmModel(modelNames.DELIVERED_SMS_COUNTER)
export default class DeliveredSmsCounter extends Counter {}
